<script setup lang="ts">
  /**
   * RadioGroupItem 单选框选项组件
   * @description
   * 1. 单个单选框选项
   * 2. 包含选中状态的指示器
   * 3. 支持禁用状态
   */
  import type { RadioGroupItemProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { Circle, Check } from 'lucide-vue-next'
  import { RadioGroupIndicator, RadioGroupItem, useForwardProps } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'

  const props = defineProps<
    RadioGroupItemProps & { class?: HTMLAttributes['class']; type?: 'circle' | 'check' }
  >()

  const delegatedProps = reactiveOmit(props, 'class')

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <RadioGroupItem
    v-bind="forwardedProps"
    :class="
      cn(
        'peer aspect-square size-4 rounded-full border border-black-white disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-brand-blue1 data-[state=disabled]:border-text-disabled',
        type === 'check' ? 'data-[state=checked]:bg-brand-blue1' : '',
        props.class,
      )
    "
  >
    <RadioGroupIndicator
      v-if="type === 'check'"
      class="flex items-center justify-center text-white"
    >
      <Check class="h-3 w-3" />
    </RadioGroupIndicator>
    <RadioGroupIndicator
      v-if="type === 'circle'"
      class="flex items-center justify-center data-[state=checked]:text-brand-blue1 data-[state=disabled]:text-text-disabled"
    >
      <Circle class="h-2.5 w-2.5 fill-current text-current" />
    </RadioGroupIndicator>
  </RadioGroupItem>
</template>
